// Import:
import { useState, useEffect } from "react"
import { useForm, Controller } from "react-hook-form"
import axios from "axios"
import Select from 'react-select'
import { useParams } from "react-router-dom"
import courseModules from '../../data/courseModules.json'
import { toast } from 'react-toastify'

// Typescript:
import { courseDataType } from "../../pages/details"
interface contactArrType {
    name: string
    email: string
    phoneNo: string
    query: string
    courseName: string
}

interface contactPropType {
    contactRef?: React.Ref<HTMLDivElement>
}

const Contact = ({contactRef}:contactPropType) => {
    // Constant:
    const params = useParams()
    const { register, control, handleSubmit, setValue, reset, formState: { errors }} = useForm<contactArrType>({
        mode: 'all',
    })

    // States:
    const [courseTitleOptions, setCourseTitleOptions] = useState<any>(courseModules?.map((course:courseDataType)=>({
        label: course?.title,
        value: course?.title
    })))

    // Functions:
    const isNumber = (str: any) => {
    if (str.trim() === '') {
        return false
    }
    return !isNaN(str)
    }
    
    const handleNumberInputChange = (str: string, id: string) => {
    if (isNumber(str)) setValue(id as any, str)
    else setValue(id as any, '')
    }

    const submitContact = async (formData:contactArrType) => {
        try {
            await axios.post('https://stepapi.stepapp.in/contact', formData)
            .then(()=> toast.success('We will call you in 24 hours'))
            .catch(error => {toast.error(`Error: ${error}`)})
        } catch (error) {
            toast.error(`Error: ${error}`)
        } finally {
            reset()
            if(params?.courseId)
                setValue('courseName', courseTitleOptions?.[Number(params?.courseId)])
            else 
                setValue('courseName','')
        }
        
    }
    // Effect:
    useEffect(()=>{
        if(params?.courseId)
            setValue('courseName', courseTitleOptions?.[Number(params?.courseId)])
    },[params?.courseId, courseTitleOptions, setValue, reset])

    return <div ref={contactRef} className='col-[2_/_3] mt-[6rem] py-[3rem] flex flex-col hmax items-start md:items-center bg-[#4545AF] text-[#ffffff]' 
                style={{boxShadow: '0 0 0 100vmax #4545AF', clipPath:'inset(0 -100vmax)'}}>
        <h2 className='text-[30px] md:text-[40px] font-extrabold mb-[20px]'>Contact us</h2>
        <div className='flex flex-wrap gap-[40px] justify-center w-full'>
            <img src='/assets/contact.png' className='object-contain h-[auto] md:w-[40%] lg:w-max hidden md:block' alt='contact'/>
            <form className='basis-[100%] md:basis-[48%] lg:basis-[40%]' onSubmit={handleSubmit(submitContact)} noValidate>
                <div className='mb-[15px]'>
                    <label className='text-[20px] '>Name</label>
                    <input type='text' className='block w-full rounded-[20px] my-[6px] px-[15px] py-[8px] text-[#000000]' {...register('name',{
                        required: {
                            value: true,
                            message: 'Please provide your name'
                        }
                    })}
                    
                    />
                    <p className='text-[16px] italic font-bold'>{errors?.name?.message}</p>
                </div>
                <div className='mb-[15px]'>
                    <label className='text-[20px]'>Email Id</label>
                    <input type='email' className='block w-full rounded-[20px] my-[6px] px-[15px] py-[8px] text-[#000000]' {...register('email',{
                        required: {
                            value: true,
                            message: 'Please provide a email'
                        },
                        pattern: {
                            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
                            message: "Invalid email address"
                        }
                    })}
                    />
                    <p className='text-[16px] italic font-bold'>{errors?.email?.message}</p>
                </div>
                <div className='mb-[15px]'>
                    <label className='text-[20px]'>Phone Number</label>
                    <input type='text' className='block w-full rounded-[20px] my-[6px] px-[15px] py-[8px] text-[#000000]' id='phoneNo' maxLength={10} {...register('phoneNo',{
                        required: {
                            value: true,
                            message: 'Please provide a phone number'
                        },
                        pattern: {
                            value: /^[0-9]{10}$/, // Matches a 10-digit numeric format
                            message: "Invalid phone number format"
                        },
                        onChange: e => {
                            handleNumberInputChange(e.target.value, e.target.id)
                        },
                    })}/>
                    <p className='text-[16px] italic font-bold'>{errors?.phoneNo?.message}</p>
                </div>
                <div className='mb-[15px]'>
                    <label className='text-[20px]'>Course Name</label>
                    <Controller
                        name="courseName" 
                        control={control} 
                        rules={{ required: {
                            value: true,
                            message: 'Please, select a course'
                        } }} 
                        render={({ field }) => (
                            <Select
                            {...field} 
                            className=" text-[black] my-[6px]"
                            placeholder='Select a Course'
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderColor: 'transparent',
                                    borderRadius: 20,
                                    padding: '8px 15px'
                                }),
                                indicatorSeparator: (baseStyles, state) => ({
                                    ...baseStyles,
                                    display: 'none'
                                    }),
                                dropdownIndicator: (provided, state) => ({
                                    ...provided,
                                    color: state.isFocused ? "#000000 !important" : "#000000 !important",
                                  })
                              }}
                            classNamePrefix="select"
                            defaultValue={field.value}
                            isSearchable={false}
                            options={courseTitleOptions}
                            />
                        )}
                        />
                    <p className='text-[16px] italic font-bold'>{errors?.courseName?.message}</p>
                </div>
                <div className='mb-[15px]'>
                    <label className='text-[20px]'>Query</label>
                    <textarea className='block w-full rounded-[20px] my-[6px] px-[15px] py-[8px] text-[#000000]' {...register('query',{
                        required: {
                            value: true,
                            message: 'Please give a detailed description of your query'
                        }
                    })}
                    style={{resize: 'none'}}
                    ></textarea>
                    <p className='text-[16px] italic font-bold'>{errors?.query?.message}</p>
                </div>
                <button className='mt-[30px] block font-bold text-[18px] rounded-[2rem] bg-[#FF6D28] text-[#F1F8FF] px-[24px] py-[12px]'
                        type='submit'>
                        Callback Request
                </button>
            </form>
        </div>
    </div>
}

export default Contact